import { render, staticRenderFns } from "./AddingExpensesProfilePopup.vue?vue&type=template&id=5fc9d4f2"
import script from "./AddingExpensesProfilePopup.vue?vue&type=script&lang=js"
export * from "./AddingExpensesProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./AddingExpensesProfilePopup.vue?vue&type=style&index=0&id=5fc9d4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports